export const fallbackLng = "en";
export const languages = ["en", "nl"] as const;
export const defaultNS = "common";

export type LanguageValue = (typeof languages)[number];

export const changeLangMessages: Record<
	LanguageValue,
	{ success: string; error: string; loading: string }
> = {
	en: {
		success: "Language has been changed!",
		error: "Error changing language!",
		loading: "Loading...",
	},
	nl: {
		success: "Taal is gewijzigd!",
		error: "Fout bij het wijzigen van de taal!",
		loading: "Laden...",
	},
};
